import './SimplePageHeader.less';

import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import HeaderArrowIcon from 'nike-ui/src/icons/svg/header-arrow-icon-sv.svg';
import HeaderCrossIcon from 'nike-ui/src/icons/svg/header-cross-icon-sv.svg';
import { withRouter } from 'react-router-dom';
import i18n from '@i18n';
import { accountUserData$ } from '@/account/subs';
import { COMMUNITY_LOBBY } from '@/routing/routes';

function BetbookPostAuthorHeader({ children, pageFixerClassName }) {
    return (
        <>
            <div className="page-header-sticker">
                <HeaderTitleContentWithRouter />
                {children}
            </div>
            <div className={clsx('page-header-fixer', { pageFixerClassName }, pageFixerClassName)} />
        </>
    );
}

function HeaderTitleContent(props) {
    const derefSub = useReframe();
    const [state, setState] = useState(false);
    const fromApp = props?.location?.state?.fromApp;
    const paramNickname = props.match.params.nickname;
    const userData = derefSub(accountUserData$);
    const nickname = userData.get('nickname');

    useEffect(() => {
        if (fromApp) {
            setState(true);
        } else {
            setState(false);
        }
    }, [fromApp]);

    function handleClick(e) {
        e.preventDefault();
        dispatch(['history_back', COMMUNITY_LOBBY]);
    }
    return (
        <nav className="simple-page-header-content">
            <div className="header-btn-go-back" data-atid="main-menu-go-back" onClick={handleClick}>
                {state ? <HeaderArrowIcon /> : <HeaderCrossIcon />}
            </div>
            <BetbookHeaderTitle nickname={nickname} paramNickname={paramNickname} />
        </nav>
    );
}

function BetbookHeaderTitle({ nickname, paramNickname }) {
    const isMyPost = nickname === paramNickname;
    return (
        <div className="simple-page-header-content-title">
            <h1>{isMyPost ? i18n('betbook.my.posts') : i18n('betbook.otherAuthor.posts')}</h1>
            {isMyPost ? null : <h3>{paramNickname}</h3>}
        </div>
    );
}

const HeaderTitleContentWithRouter = withRouter(HeaderTitleContent);

export default BetbookPostAuthorHeader;
